import { render, staticRenderFns } from "./photo-slider.vue?vue&type=template&id=bec033e0&scoped=true&"
import script from "./photo-slider.vue?vue&type=script&lang=js&"
export * from "./photo-slider.vue?vue&type=script&lang=js&"
import style0 from "./photo-slider.vue?vue&type=style&index=0&id=bec033e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bec033e0",
  null
  
)

export default component.exports